"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useDocuments = void 0;
const react_query_1 = require("react-query");
const elements_core_rest_transport_1 = require("@hydrogen/elements.core.rest.transport");
const elements_data_wealth_app_use_contact_id_1 = require("@hydrogen/elements.data.wealth.app.use-contact-id");
const useDocuments = ({contractId, showOnlyClientsDocuments, skip, take, fields = [], orders = [], language = 'en', }) => {
    const contactId = (0, elements_data_wealth_app_use_contact_id_1.useContactId)();
    const query = (0, react_query_1.useQuery)(['documents', showOnlyClientsDocuments, skip, take, fields, orders, contactId, language, contractId], () => (0, elements_core_rest_transport_1.baseApi)(global?.AppConfig?.DSL_URL_SUFFIX).post(`/v1/documents/contacts/${contactId}/search/${language}`, {
        showOnlyClientsDocuments,
        skip,
        take,
        fields,
        orders,
        contractId
    }), {
        enabled: (fields === null || fields === void 0 ? void 0 : fields.length) > 0,
        keepPreviousData: true,
        select({ data }) {
            return data;
        },
    });
    return Object.assign(Object.assign({}, query), { isLoading: query.isIdle || query.isLoading || (query.isPreviousData && query.isFetching) });
};
exports.useDocuments = useDocuments;
//# sourceMappingURL=use-documents.js.map